import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { EmployeeService } from "../../core/services/employee.service";
import { Employee } from "../../core/models/employee.model";
import { FormBuilder, FormGroup } from "@angular/forms";

@Component({
    selector: 'app-employee-show',
    templateUrl: './employee-show.component.html',
    styleUrls: ['./employee-show.component.css']
})
export class EmployeeShowComponent implements OnInit {
    employee: Employee;
    employeeForm: FormGroup;

    constructor(
        private route: ActivatedRoute,
        private employeeService: EmployeeService,
        private fb: FormBuilder,
    ) {
        this.employeeForm = this.fb.group({
            'name': [''],
            'mobile_number': [''],
            'father_name': [''],
            'dob': [''],
            'client_employee_id': [''],
            'age': [''],
            'interim_report_date': [''],
            'expected_joining_date': [''],
            'employment_type': [''],
            'completion_date': [''],
            'navigation': '',
            'email': ['']
        });

    }

    ngOnInit() {
        this.employeeForm.disable();
        this.route.paramMap
            .switchMap((params: ParamMap) => this.employeeService.find(+params.get('id')),)
            .subscribe(employee => this.employee = employee);
    }

}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/employee/employee-show/employee-show.component.ts